import { useEffect, useId, useRef, type ReactNode } from 'react';
import { uiText } from '../i18n';
import { Sheet } from './Sheet';
import './text-editor.css';

/** Редактор шаблона: отдельный слой над настройками, ввод сразу меняет исходное React-поле. */
export function TextEditor({
  label,
  value,
  limit,
  disabled,
  onChange,
  onClose,
  toolbar,
}: {
  label: string;
  value: string;
  limit: number;
  disabled?: boolean;
  onChange(value: string): void;
  onClose(): void;
  toolbar?: ReactNode;
}) {
  const id = useId();
  const input = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    const element = input.current;
    const frame = requestAnimationFrame(() => {
      element?.focus({ preventScroll: true });
      element?.setSelectionRange(value.length, value.length);
    });
    return () => cancelAnimationFrame(frame);
    // Каретка задаётся один раз при открытии.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const count = Array.from(value).length;
  return (
    <Sheet id={`text-editor-${id}`} label={label} open modal layer onClose={onClose} className="bc-edw on react-text-editor">
      <div className="bc-edscr" onClick={onClose} aria-hidden="true" />
      <div className="bc-ed">
        <span className="bc-edg" aria-hidden="true" />
        <div className="bc-edh">
          <button type="button" className="bc-edok" onClick={onClose}>
            {uiText('Сохранить')}
          </button>
          <div className="m" />
          <span className={`cnt mono${count > limit ? ' bad' : ''}`} aria-live="polite">
            {count} / {limit}
          </span>
          <button type="button" className="iconb" data-bsheet-x aria-label={uiText('Закрыть')} onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
              <path d="m6 6 12 12M6 18 18 6" />
            </svg>
          </button>
        </div>
        {toolbar && (
          <div
            className="bc-edk imp"
            onMouseDown={event => {
              if (event.target instanceof Element && event.target.closest('button')) event.preventDefault();
            }}
          >
            {toolbar}
          </div>
        )}
        <textarea
          ref={input}
          className="bc-edta"
          aria-label={label}
          value={value}
          maxLength={limit * 2}
          disabled={disabled}
          onChange={event => onChange(Array.from(event.target.value).slice(0, limit).join(''))}
        />
      </div>
    </Sheet>
  );
}
